'use strict';

import React, { Component } from 'react';

var Moment = require('moment'),
    $ = require('jquery');

class Card extends Component{
       emptyList = [];
        state = {
            //Initiate Default User
            codeValue: "",
            comment: "",
            value: "",
            listBox: this.emptyList,
        }
    componentDidMount= () => {
      //Get Data From paygo User
      console.log("Token User : ", this.props.tokenUser);
      var methodName = 'GetList class';
      var url = "/user/paygoboxlist";
      var testTime = Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
      console.log('[DEBUG], ', methodName, ',URL :, ', url, ' & ', testTime);

      this.serverRequest = $.get(url, function(result) {
          console.log('[INFO],  reception des données  des utilisateur de PAYGO ');
          console.log(result);
          var optionTmp = [];
          try {
              var data = result; //var data = JSON.parse(result);

              for (var i = 0; i < data.userList.length; i += 1) {
                  optionTmp.push({id: data.userList[i].name, value: data.userList[i].name})
              }
          } catch (e) {
              // les instructions utilisées pour gérer les
              // exceptions
              console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
              console.log(e); // on transfère l'objet de l'exception à une méthode
              console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
              return;
          }
          this.setState({listBox: optionTmp});
      }.bind(this));
    }
    componentWillUnmount= () => {
      try {
          this.serverRequest.abort();
      } catch (e) {
          console.log(e);
      }
    }
    onClickHandle= () => {
        console.log('Click to send Code: ', this.state.codeValue);

        var methodName = 'onClickHandle class';
        var url = "/user/paygo/code/update/asadmin?codeId="+this.state.codeValue+"&adminId="+this.state.value;

        this.serverRequest = $.get(url, function(result) {
            console.log('[INFO],  reception de validation du code de PAYGO ');
            console.log(result);
            var message = "";
            try {
                var data = result; //var data = JSON.parse(result);
                console.log(result);
                message = data.message;

            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }

            this.setState({comment: message});
        }.bind(this));
    }
    codeOnChangeHandle= (e) => {
        e.preventDefault();
        this.setState({codeValue: e.target.value});
    }
    onChange= (e) => {
        e.preventDefault();
        var paygoId = e.target.value;
        this.setState({value: paygoId});
    }
    render() {
        console.log('[INFO], render fonction Main PAYG');
        var valueList = this.state.listBox;

        //Order by name
        valueList.sort(function(a, b) {
            if (a.value>b.value){
              return -1;
            }
            if (a.value < b.value){
              return 1;
            }
            return 0;
        });
        return (
            <div className="container">
                <div className="card">
                    <div className="card-header">
                        <h1>Enter un code pour débloquer votre système
                        </h1>
                    </div>

                    <div id="data-table-basic-header" className="bootgrid-header container-fluid">
                        <div className="row">
                            <div className="col-sm-12 actionBar">
                                <div className="search form-group">
                                    <div className="input-group">
                                        <span className="zmdi icon input-group-addon glyphicon-search"></span>

                                        <select className="search-field form-control" value={this.state.value} onChange={this.onChange}>
                                            {valueList.map(function(optionval) {
                                                return <option value={optionval.id}>{optionval.value}</option>;
                                            })
}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="fg-line">
                            <input type="text" className="form-control input-sm" placeholder="Enter Code" onChange={this.codeOnChangeHandle} value={this.state.codeValue}/>
                        </div>
                    </div>
                    {this.state.comment}
                    <div className="btn-demo">
                        <button className="btn btn-success waves-effect" onClick={this.onClickHandle}>Test Code</button>
                    </div>

                </div>
            </div>
        );
    }
};
export default Card;

//module.exports = Card;
